import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import {Toggle} from '../../../../../../form/form.jsx';

const IfContact = () => {
  const [field, , helpers] = useField('manager_sign');

  return (
    <Toggle
      label={t`Manager’s name in message`}
      isChecked={field.value}
      onChange={helpers.setValue}
    />
  );
};

export default IfContact;
